import map from 'lodash/map';
import reduce from 'lodash/reduce';
import {
  ADDON_DVP,
  ADDON_EXTENSION,
  ADDON_PMV,
} from '../config/constants/addon-types';

// Compute the total cost of the purchase
export const getAddonTotal = (addons) => {
  const value = reduce(
    map(addons, (addon, index) => {
      let price;
      if (addon.addonType === ADDON_EXTENSION) {
        price = addon.extensionPrice.amount;
      }
      if (addon.addonType === ADDON_PMV) {
        price = addon.protectMyVoucherPrice.amount;
      }
      if (addon.addonType === ADDON_DVP) {
        price = addon.price;
      }

      return Number(price);
    }),
    (runningTotal, amount) => {
      return runningTotal + amount;
    },
    0,
  );

  return Number(value.toFixed(2));
};
